// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__WP__5","content":"styles_content__26iUR","budget":"styles_budget__vUOXz","title":"styles_title__dpqtp"};